import { generateId } from "@msuite/utils/strings";
import type { DashboardTileItem } from "@msuite/utils/types";
import { motion } from "motion/react";
import React, { useState } from "react";
import type { ChildrenProps, ClassNameProps } from "../types";
import { cn } from "../utils";
import { DashboardTileControls } from "./dashboard-tile-controls";
import { DashboardTileList } from "./dashboard-tile-list";

/** Props Interface */
interface DashboardTileProps extends ChildrenProps, ClassNameProps {
	item: DashboardTileItem;
}

function DashboardTile({ children, className }: DashboardTileProps) {
	/** State */
	const [layoutId] = useState(generateId());

	/** Render */
	return (
		<React.Fragment>
			<div className="absolute inset-0 card bg-primary-50 dark:bg-primary-800 fat-stripes">
				<motion.div
					className={cn(
						"card rounded-[0.65rem] absolute inset-0.5 px-6 pb-4 pt-14 overflow-hidden rounded-md",
						className,
					)}
					layoutId={layoutId}
				>
					<div className="absolute inset-x-6 inset-y-4 flex flex-col">{children}</div>
				</motion.div>
			</div>
		</React.Fragment>
	);
}

DashboardTile.List = DashboardTileList;
DashboardTile.Controls = DashboardTileControls;

export { DashboardTile };
